'use strict'

const React = require('react')
const createReactClass = require('create-react-class')
const PropTypes = require('prop-types')
const cookie = require('react-cookie')
const classNames = require('classnames')
const ParkingEngine = require('./parking-engine.jsx')
const HotelEngine = require('./hotels-engine.jsx')
const Modal = require('../../../../shared/_layouts/_templates/_includes/modal.jsx')
const HotelParkingEngine = require('./hotel-parking-engine.jsx')
const Helpers = require('../../../../_plugins/lib/helpers.js')
const PPCGetQuery = require('../../../../_plugins/lib/ppc.js')
const { string, object, array, func, bool } = PropTypes

const MultiEngine = createReactClass({
  mixins: [Helpers],

  propTypes: {
    agentData: object.isRequired,
    selectedClass: string,
    hiddenLocation: string,
    cookieKey: string,
    domainSettings: object,
    formSettings: object,
    productList: array,
    locations: object,
    RoomTypes: object,
    pageData: object,
    setVar: object,
    agentSettings: object,
    engineSearchField: string,
    productCallBack: func,
    terminal: string,
    showFlight: bool
  },

  getInitialState () {
    return {
      selectedProduct: this.getSelectedProduct(this.props.agentData)
    }
  },

  shouldComponentUpdate (nextProps, nextState) {
    if (nextState.selectedProduct !== this.state.selectedProduct) return true
    if (nextProps.hiddenLocation !== this.props.hiddenLocation) return true
    if (JSON.stringify(nextProps.agentData) !== JSON.stringify(this.props.agentData)) {
      this.setState({
        selectedProduct: this.getSelectedProduct(nextProps.agentData)
      })
      return true
    }
    return false
  },

  getLocationFromParam () {
    const queryString = PPCGetQuery.getQueryData()
    return queryString.location || queryString.Location || ''
  },

  getDefaultProps () {
    return {
      selectedClass: ' active',
      cookieKey: 'chosenEngine',
      setVar: { },
      terminal: '',
      showFlight: false
    }
  },

  setEngineCookie (product) {
    const { cookieKey } = this.props
    cookie.remove(cookieKey, '/')
    const expiry = new Date()
    expiry.setTime(expiry.getTime() + (90 * 24 * 60 * 60 * 1000))
    cookie.save(cookieKey, product, { expires: expiry, path: '/' })
  },

  getEngineCookie () {
    const { cookieKey, setVar } = this.props
    const selectedProduct = cookie.load(cookieKey)
    if (!selectedProduct) return false
    if (!this.showEngineProduct(null, selectedProduct)) return false
    if (setVar[selectedProduct + '-engine-link']) return false
    return selectedProduct
  },

  getDefaultProduct () {
    const { productList = [ ] } = this.props
    if (productList.length && productList.indexOf('cp') < 0) return 'hcp'
    return 'cp'
  },

  getSelectedProduct (agentData = { }) {
    const { formSettings: { engineOptions = { } }, productList = [ ] } = this.props
    const { OptionFlags } = agentData
    let selectedProduct = this.getDefaultProduct()
    if (this.getEngineCookie()) selectedProduct = this.getEngineCookie()
    const queryString = PPCGetQuery.getQueryData()
    if (queryString.chosen) {
      const chosen = queryString.chosen.toLowerCase()
      if (productList.length && productList.indexOf(chosen) >= 0) {
        selectedProduct = chosen
      } else if (Object.keys(engineOptions).indexOf(chosen) >= 0) {
        selectedProduct = chosen
      }
    }
    if (!OptionFlags) {
      try {
        performance.mark('Default selected engine option') // eslint-disable-line no-undef
      } catch (e) {
        // console.log( e );
      }
      return selectedProduct
    }
    if (OptionFlags.CarParkBookings === 'N' && OptionFlags.HotelBookings !== 'N' && OptionFlags.HotelParking === 'N') {
      selectedProduct = 'ho'
    } else if (OptionFlags.CarParkBookings === 'N' && OptionFlags.HotelParking !== 'N') {
      selectedProduct = 'hcp'
    } else if (OptionFlags.HotelBookings === 'N' && OptionFlags.CarParkBookings !== 'N') {
      selectedProduct = 'cp'
    }
    try {
      performance.mark('Changed selected engine option') // eslint-disable-line no-undef
    } catch (e) {
      // console.log( e );
    }
    return selectedProduct
  },

  navigate (link) {
    window.location = link
  },

  clickLink (e) {
    const { productCallBack } = this.props
    let el = e.target
    let iterator = 0
    while (el.tagName !== 'A' && iterator++ <= 3) {
      el = el.parentElement
      const anchor = this.$('a', el)
      if (anchor) el = anchor.target
    }
    if (!el || el.tagName !== 'A') return false
    let link = el.getAttribute('data-link')
    const modal = (el.getAttribute('data-toggle') === 'modal')
    const mobileLink = el.getAttribute('data-mobile-link')
    const selectedProduct = el.getAttribute('data-product')
    const { flatEngine } = this.refs
    // on mobile layout we hide the engine so lets link to the pages instead
    const isMobile = this.isVisible('.visible-xs', flatEngine)

    if (!link && !modal) {
      this.setEngineCookie(selectedProduct)
      this.setState({
        selectedProduct
      })
      if (productCallBack) productCallBack(selectedProduct)
    }
    if (link || (isMobile && mobileLink)) {
      this.navigate(link || mobileLink)
    }
    return false
  },

  makeOption ({ productClass, product, text, link, mobileLink, modalHeading, modalLead, modalContent, svg }, key, groupName) {
    const { selectedProduct } = this.state
    let { selectedClass, setVar, agentData } = this.props
    if (setVar[product + '-engine-link']) link = setVar[product + '-engine-link']
    const checked = selectedProduct === product
    const classUsed = classNames(
      productClass,
      checked ? selectedClass : null,
      ((productClass === 'cp' || productClass === 'ho' || productClass === 'hcp') && groupName !== 'selectProductSplit' && groupName !== 'landingPage') ? 'hidden-xs' : null
    )

    return (
      <li key={key} className={classUsed}>
        { ((modalHeading || modalLead || modalContent) && (
          <a data-product={product} data-link={link} onClick={this.clickLink} data-mobile-link={mobileLink} htmlFor={'hxEmbedsp_' + product} data-toggle='modal' data-target={'#' + product + 'EngineModal'} data-track-name='select_product' data-track-value={product}><small dangerouslySetInnerHTML={{ __html: text }} />{ svg && (<span className='hidden-xs' dangerouslySetInnerHTML={{ __html: svg }} />)}</a>
        )) || (
          <a data-product={product} data-link={link} onClick={this.clickLink} data-mobile-link={mobileLink} htmlFor={'hxEmbedsp_' + product} dangerouslySetInnerHTML={{ __html: text }}>
            { svg && (<span className='hidden-xs' dangerouslySetInnerHTML={{ __html: svg }} />)}
          </a>
        ) }
        { (modalHeading || modalLead || modalContent) && (<Modal id={product + 'EngineModal'} heading={modalHeading} lead={modalLead} content={modalContent.replace('##agent##', agentData.agent)} />) }
      </li>
    )
  },

  cantSellProduct (item, OptionFlags, selectedProduct, agent, groupCode) {
    if (selectedProduct !== item.product && OptionFlags && item.canSellFlag && OptionFlags[item.canSellFlag] === 'N') return true
    return ((item.agentExclude && item.agentExclude.indexOf(agent) > -1) || (item.agentGroupExclude && item.agentGroupExclude.indexOf(groupCode) > -1))
  },

  showEngineProduct (option, productType) {
    const { productList = [ ], agentData: { OptionFlags } } = this.props
    if (productList.length && productList.indexOf(productType) < 0) return false
    if (!OptionFlags || !option) return true
    if (OptionFlags[option] === 'N') return false
    return true
  },

  getEngineOptions (productList, groupName) {
    const { agentData, formSettings: { engineOptions } } = this.props
    const { selectedProduct } = this.state
    const { OptionFlags, agent, groupCode } = agentData
    if (!productList.length) {
      return Object.keys(engineOptions).reduce((result, option) => {
        const product = engineOptions[ option ]
        if (this.cantSellProduct(product, OptionFlags, selectedProduct, agent, groupCode)) return result
        result.push(this.makeOption(product, option, groupName))
        return result
      }, [ ])
    }
    return productList.reduce((products, product) => {
      const result = Object.keys(engineOptions).filter(option => {
        const engineOption = engineOptions[option]
        if (engineOption.product !== product) return false
        if (this.cantSellProduct(engineOption, OptionFlags, selectedProduct, agent, groupCode)) return false
        return true
      })
      if (!result.length) return products
      products.push(this.makeOption(engineOptions[result[0]], products.length, groupName))
      return products
    }, [ ])
  },

  render () {
    const {
      domainSettings,
      formSettings,
      locations,
      RoomTypes,
      pageData,
      hiddenLocation,
      agentSettings,
      agentData,
      setVar,
      engineSearchField,
      terminal,
      productList = [ ],
      showFlight
    } = this.props
    const { selectedProduct } = this.state
    const groupName = pageData.pageName === 'index' ? 'selectProduct' : 'landingPage'
    const engineOptions = this.getEngineOptions(productList, groupName)
    let splitProducts = false
    if (pageData.pageName === 'index') {
      splitProducts = this.getEngineOptions([ 'ho', 'hcp', 'cp' ], 'selectProductSplit')
    }

    let hotelEngineLabels = formSettings.hotelLabels
    const productClass = classNames({
      'nav': true,
      'nav-tabs': true,
      'nav-justified': splitProducts,
      'sp': true
    })

    return (
      <div id='engineHrzntl' ref='flatEngine'>
        { (engineOptions.length !== 1 || pageData.pageName === 'index') && (
          <ul className={productClass}>{ engineOptions }</ul>
        )}
        { this.showEngineProduct('HotelBookings', 'ho') &&
          <HotelEngine labels={hotelEngineLabels.ho} showFlight={showFlight} domainSettings={domainSettings} formSettings={formSettings} locations={locations} RoomTypes={RoomTypes} hiddenLocation={hiddenLocation} Location={this.getLocationFromParam()} pageData={pageData} agentSettings={agentSettings} agentData={agentData} selected={selectedProduct} engineSearchField={engineSearchField} terminal={terminal} />
        }
        { this.showEngineProduct('HotelBookings', 'hcp') &&
          <HotelParkingEngine labels={hotelEngineLabels.hcp} showFlight={showFlight} domainSettings={domainSettings} formSettings={formSettings} locations={locations} RoomTypes={RoomTypes} hiddenLocation={hiddenLocation} Location={this.getLocationFromParam()} pageData={pageData} agentSettings={agentSettings} agentData={agentData} selected={selectedProduct} engineSearchField={engineSearchField} terminal={terminal} />
        }
        { this.showEngineProduct('CarParkBookings', 'cp') &&
          <ParkingEngine showFlight={showFlight} domainSettings={domainSettings} formSettings={formSettings} locations={locations} hiddenLocation={hiddenLocation} Location={this.getLocationFromParam()} pageData={pageData} agentSettings={agentSettings} agentData={agentData} selected={selectedProduct} showFilters={setVar.showFilters === 'true'} engineSearchField={engineSearchField} terminal={terminal} />
        }
        { engineOptions.length !== 1 && splitProducts && (
          <div className='visible-xs'>
            <ul className='nav nav-tabs sp'>{ splitProducts }</ul>
          </div>
        )}
      </div>
    )
  }
})

module.exports = MultiEngine



// WEBPACK FOOTER //
// ./_layouts/_templates/_includes/engine-horizontal/engine-controller.jsx